import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Spinner from "react-bootstrap/Spinner";
import { Link, useNavigate } from "react-router-dom";
import swal from "sweetalert";
import Logo from '../Images/kuza-new.svg'

// Firebase
import { app } from "../firebase.js";
import { getAuth, RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
import { getFirestore, collection, query, getDocs, where, doc, setDoc } from "@firebase/firestore";

//input 
import InputGroup from 'react-bootstrap/InputGroup';
import kenyaImg from '../Images/kenyaflag.png'


function SignIn() {

    const [phone, setPhone] = useState("");
    const [otp, setOtp] = useState("");
    const [name, setName] = useState(""); // Store user's name
    const [businessType, setBusinessType] = useState();
    const [isVerified, setIsVerified] = useState(false); // Track OTP verification
    const [confirmationResult, setConfirmationResult] = useState(null); // Store confirmationResult
    const [loading, setLoading] = useState(false);
    const [sendOtpCont, setsendOtpCont] = useState(true);
    const navigate = useNavigate();
    const auth = getAuth(app);
    const [hideButtonWhenRepatchaAppers, sethideButtonWhenRepatchaAppers ] = useState(true)
    const [userCode, setUserCode] = useState("+254");
    const [countryLogo, setcountryLogo] = useState(kenyaImg); 

    const [apiClientIDr, setapiClientID] = useState("");
    const [keyr, setkey] = useState("");
    const [secretr, setsecret] = useState("");
    const [serviceIDr, setserviceID] = useState(0);
    const [serviceIDTwor, setserviceIDTwo] = useState(0);
    const [referralCode, setReferralCode] = useState("");

    useEffect(() => {
      const query = new URLSearchParams(window.location.search);
      const urlRef = query.get("ref");

      if (urlRef) {
        setReferralCode((prev) => (prev ? prev : urlRef));
      }
    }, []); // 👈 only run once on mount




    const db = getFirestore(app);


   useEffect(() => {
    if (isVerified) {
      const fetchGlobalSettings = async () => {
        try {
          const userQuery = query(
            collection(db, "globalSettings"),
            where("docID", "==", "wqSDO1OEBintZqf0svF6")
          );
          const querySnapshot = await getDocs(userQuery);

          querySnapshot.forEach((docSnap) => {
            const data = docSnap.data();
            setapiClientID(data.apiClientID);
            setkey(data.key);
            setsecret(data.secret);
            setserviceID(data.serviceID);
            setserviceIDTwo(data.serviceIDTwo);
          });
        } catch (error) {
          console.error("Error fetching global settings:", error);
          swal("Error", "Failed to fetch system settings.", "error");
        }
      };

      fetchGlobalSettings();
    }
  }, [isVerified]); // 👈 triggers when OTP is verified


  
  
  //format the phone number 
  const formatPhoneNumber = (number) => {
      // Remove non-numeric characters
      let cleaned = number.replace(/[^0-9]/g, '');
    
      // Handle different cases
      if (cleaned.startsWith('0')) {
        cleaned = '254' + cleaned.slice(1); // Replace leading 0 with 254
      } else if (cleaned.startsWith('7')) {
        cleaned = '254' + cleaned; // Add 254 if it starts with 7
      } else if (cleaned.startsWith('1')) {
        cleaned = '254' + cleaned; // Handle landlines starting with 1
      } else if (cleaned.startsWith('+254')) {
        cleaned = cleaned.slice(1); // Remove +
      } else if (!cleaned.startsWith('254')) {
          swal("Error", "Invalid phone number format. Please enter a valid Kenyan number starting with 07 or 01.", "error");
        return null;
      }
    
      // Validate length (should be exactly 12 digits)
      if (cleaned.length === 12 && cleaned.startsWith('254')) {
        return `+${cleaned}`; // Ensure +254XXXXXXXXX format
      } else {
          swal("Error", "Invalid phone number format. Please enter a valid Kenyan number starting with 07 or 01.", "error");
        return null;
      }
    };
    
    
  
    const setupRecaptcha = () => {
      if (!window.recaptchaVerifier) {
          
        window.recaptchaVerifier = new RecaptchaVerifier(auth, "recaptcha-container", {
          
          size: "normal",
          callback: () => {
            console.log("reCAPTCHA verified");
          },
          "expired-callback": () => {
            console.log("reCAPTCHA expired, please refresh.");
          }
        });
        window.recaptchaVerifier.render().then((widgetId) => {
          window.recaptchaWidgetId = widgetId;
          sethideButtonWhenRepatchaAppers(false);
        });
      }
    };
  
    const sendOtp = async () => {
      const cleanedPhone = formatPhoneNumber(phone);
      //console.log(cleanedPhone)
      if (!cleanedPhone) {
          swal("Error", "Invalid phone number format. Please enter a valid Kenyan number starting with 07 or 01.", "error");
          return;
      }
  
      setLoading(true);
      setupRecaptcha();
      const appVerifier = window.recaptchaVerifier;
    
  
      try {
        const result = await signInWithPhoneNumber(auth, cleanedPhone, appVerifier);
        setConfirmationResult(result); // Store confirmation result
        setsendOtpCont(false)
        swal("OTP Sent", "Check your phone for the OTP.", "success");
      } catch (error) {
        //console.error("OTP Error:", error.message);
        swal("Error", "Failed to send OTP. Try again.", "error");
      } finally {
        setLoading(false);
      }
    };
  
    const verifyOtp = async () => {
      if (!confirmationResult) {
        //console.error("No confirmation result. Please request OTP again.");
        swal("Error", "Please request OTP again.", "error");
        return;
      }
  
      setLoading(true);
      
      const usersRef = collection(db, "users"); // Reference to users collection
      const cleanedPhone = formatPhoneNumber(phone);
  
  
      try {
        const result = await confirmationResult.confirm(otp);
        const user = result.user; // Now user is safely defined
        swal("Success", "Phone number verified successfully!", "success");
        //navigate("/dashboard"); // Redirect to a dashboard or home page
  
          // Check if the user exists in Firestore
          const userQuery = query(usersRef, where("phone", "==", cleanedPhone));
          const querySnapshot = await getDocs(userQuery);
  
          if (querySnapshot.empty) {
  
              setIsVerified(true); // Set verification flag to true
  
          } else {
              //toast
              navigate("/dashboard");
          }
  
      } catch (error) {
        console.error("Error verifying OTP:", error.message);
        swal("Error", "Invalid OTP. Try again.", "error");
      } finally {
        setLoading(false);
      }
    };
  
    function generateApiKey() {
      const array = new Uint32Array(10);
      crypto.getRandomValues(array);
      return Array.from(array, dec => dec.toString(16)).join("");
    }

  
    const handleContinue = async () => {
      const cleanedPhone = formatPhoneNumber(phone);
      if (!name.trim()) {
          swal("Error", "Please enter your full name.", "error");
          return;
      }
  
      setLoading(true);
      const db = getFirestore(app);
      const usersRef = collection(db, "users");
      const smsRef = collection(db, "smsSenders");
      const bulkSmsRef = collection(db, "bulkSmsSenders");


      try {
          const userDocRef = doc(usersRef, auth.currentUser.uid);
          await setDoc(userDocRef, {
              phone: cleanedPhone,
              signeUpDate: new Date(),
              businessName: name,
              businessType:businessType,
              userId: auth.currentUser.uid,
              status: "Unsubscribed",
              purchasedSMS:0,
              issuedSMS:"10",
              signUpVia:"Web",
              apiKey: generateApiKey(),
              referralCode: referralCode?.trim() || null,
          }).then(()=>{

            const smsDocRef = doc(smsRef, auth.currentUser.uid);
            setDoc(smsDocRef, {
                apiClientID: apiClientIDr,
                key: keyr,
                secret: secretr,
                serviceID:serviceIDr,
                userId: auth.currentUser.uid,
                status: "defaultID",
            }).then(()=>{

              const bulkSmsDocRef = doc(bulkSmsRef, auth.currentUser.uid);
              setDoc(bulkSmsDocRef, {
                  apiClientID: apiClientIDr,
                  key: keyr,
                  secret: secretr,
                  serviceID:serviceIDTwor,
                  userId: auth.currentUser.uid,
                  status: "defaultID",
              }).then(()=>{

                  const smsMessage = `Hey ${name}, Welcome to Kuza Points! You have successfully signed up as a ${businessType}. Reward your customers with points for every visit. Let us help you grow your business through loyalty. Kuza makes it possible. Manage your business on the go! Download the Kuza Points Android App now: https://play.google.com/store/apps/details?id=com.kuza.points`
                  const smsSent = sendSms(smsMessage, cleanedPhone);
                  if (smsSent) {
                    swal('Success', 'Account created successfully!', 'success').then(() => {
                      navigate("/dashboard");
                    });
                  } else {
                    swal('Success', 'Account created successfully!', 'success').then(() => {
                      navigate("/dashboard");
                    });
                  }

              })          
            })

          })
  
      } catch (error) {
          swal("Error", "Failed to create account. Try again.", "error");
      } finally {
          setLoading(false);
      }
  };
  
  

      //send sms
    const sendSms = async (message, phoneNumber) => {
        const auth = getAuth();
        const user = auth.currentUser;
    
        if (!user) {
            console.error("User not logged in");
            return;
        }
    
        try {
            const token = await user.getIdToken();
    
            const response = await fetch("https://us-central1-kuzapoints.cloudfunctions.net/sms/send-sms", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ message, phoneNumber }),
            });
    
            const data = await response.json();
    
            if (response.ok) {
              console.log("karibu")
            } else {
              console.log("karibu")
            }
        } catch (err) {
            console.log("karibu")
        }
    };
      //end sms


  
  
    return (
      <div className='authMain'>
  
        <div className='authLeft'> 
  
        </div>
  
          <div className='authRight'>
              <div>
              <Link to='/' ><img src={Logo} alt="" className="authRightLogo"/></Link>
              <h2 className="myPrimaryColor">Sign In</h2>
              </div>
  
          <div>
              {sendOtpCont && (<>
                  <Form.Group className="mb-3">
                  <Form.Label className="myPrimaryColor">Enter your Phone Number to Login or Register</Form.Label>
  
                  </Form.Group>
  
                      <InputGroup className="mb-3">
                          <InputGroup.Text id="basic-addon1" className="countryIconCont">
                              <img src={countryLogo}  className='countryIcon' alt="" />
                          </InputGroup.Text>                  
                          <Form.Control
                              type="tel"
                              placeholder="07XXXXXX"
                              value={phone}
                              onChange={(e) => setPhone(e.target.value)}
                          />
                      </InputGroup>
  
  
  
                
                      <p className=' myPrimaryColor'>By signing in, you agree to the <Link to='/terms-of-use' className='termsOfServiceText2'>Terms of use</Link></p>
                 
  
                  {hideButtonWhenRepatchaAppers && (<> 
                      <Button 
                      variant="primary" 
                      onClick={sendOtp} 
                      disabled={loading} 
                      className="btnLogin w-100"
                      >
                      {loading ? (
                          <>
                          <Spinner as="span" animation="border" size="sm" className="me-2" />
                          Signing In...
                          </>
                      ) : (
                          "Send OTP"
                      )}
                      </Button>
                  
                  </>)}
                  
                  <br />
  
                  <div id="recaptcha-container"></div>     
              </>)}
  
  
              {confirmationResult && !isVerified &&  (
              <>
  
                  <Form.Group className="mt-3">
                  <Form.Label>Enter OTP</Form.Label>
                  <Form.Control
                      type="text"
                      placeholder="Enter OTP"
                      value={otp}
                      onChange={(e) => setOtp(e.target.value)}
                  />
                  </Form.Group>
  
                  <Button variant="success" className="mt-3 btnLogin w-100" onClick={verifyOtp} disabled={loading} > 
                  {loading ? (
                          <>
                          <Spinner as="span" animation="border" size="sm" className="me-2" />
                          Signing In...
                          </>
                      ) : (
                          "Verify OTP"
                      )}
                  </Button>
              </>
              )}
  
              {/* Show name input only after OTP is verified */}
              {isVerified && (
                  <>

                      <Form.Group className="mt-3">
                        <Form.Label>Select Business Type</Form.Label>
                        <Form.Select
                          value={businessType}
                          onChange={(e) => setBusinessType(e.target.value)}
                        >
                          <option value="">Select your business Type</option>
                          <option value="Carwash">Carwash</option>
                          <option value="Barber Shop">Kinyozi (Barber Shop)</option>
                          <option value="Petrol Station">Petrol Station</option>
                          <option value="Salon">Salon</option>
                          <option value="Nail Bar">Nail Bar</option>
                          <option value="Spa">Spa / Massage</option>
                          <option value="Beauty Parlour">Beauty Parlour</option>
                          <option value="Garage">Garage / Mechanic</option>
                          <option value="Transport">Transport</option>
                          <option value="Logistics">Logistics</option>
                          <option value="Phone Repair">Phone Repair</option>
                          <option value="Tailor">Tailor / Fashion Shop</option>
                          <option value="Laundry">Laundry / Dry Cleaner</option>
                          <option value="Restaurant">Restaurant / Cafe</option>
                          <option value="Retail Shop">Retail Shop</option>
                          <option value="Grocery Store">Grocery Store</option>
                          <option value="Entertainment Joint">Entertainment Joint</option>
                          <option value="Other">Other</option>

                        </Form.Select>
                      </Form.Group>

                      <Form.Group className="mt-3">
                          <Form.Label>Business Name</Form.Label>
                          <Form.Control
                              type="text"
                              placeholder="Enter your full name"
                              value={name}
                              onChange={(e) => setName(e.target.value)}
                          />
                      </Form.Group>

                      <Form.Group className="mt-3">
                          <Form.Label>referral code (optional)</Form.Label>
                          <Form.Control
                              type="text"
                              placeholder="Enter a referral code"
                              value={referralCode}
                              onChange={(e) => setReferralCode(e.target.value)}
                          />
                      </Form.Group>
  
                      <Button variant="primary" className="mt-3 btnLogin w-100" onClick={handleContinue} disabled={loading}>
                      {loading ? (
                          <>
                              <Spinner as="span" animation="border" size="sm" className="me-2" />
                              Creating Account...
                          </>
                      ) : (
                          "Finish"
                      )}
                  </Button>
                  </>
              )}
          </div>
  
        </div>
      </div>
    );
}


export default SignIn